import { render, staticRenderFns } from "./AdditionalProfileData.vue?vue&type=template&id=86b48f20&scoped=true&"
import script from "./AdditionalProfileData.vue?vue&type=script&lang=js&"
export * from "./AdditionalProfileData.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalProfileData.vue?vue&type=style&index=0&id=86b48f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b48f20",
  null
  
)

export default component.exports